<div class="requirements">
  @if (solo) {
  <div class="solo">
    <span [ghs-label]="'scenario.requirements.solo'" [ghs-label-args]="[scenarioData.edition, solo]"></span>
  </div>
  }
  @for (requirement of requirements | trackUUID; track requirement._trackUUID; let i = $index) {
  <div class="requirement">
    <div class="party">
      @for (achievement of requirement.partyAchievements; track achievement) {
      <div class="achievement" [ghs-label]="'scenario.requirements.party'" [ghs-label-args]="[achievement]"></div>
      }
    </div>
    <div class="party">
      @for (achievement of requirement.partyAchievementsCount; track achievement) {
      <div class="achievement" [ghs-label]="'scenario.requirements.partyCount'"
        [ghs-label-args]="[achievement.name, (achievement.required - achievement.count) , achievement.required]">
      </div>
      }
    </div>
    <div class="party">
      @for (achievement of requirement.partyAchievementsMissing; track achievement) {
      <div class="achievement" [ghs-label]="'scenario.requirements.partyMissing'" [ghs-label-args]="[achievement]">
      </div>
      }
    </div>
    <div class="global">
      @for (achievement of requirement.globalAchievements; track achievement) {
      <div class="achievement" [ghs-label]="'scenario.requirements.global'" [ghs-label-args]="[achievement]"></div>
      }
    </div>
    <div class="global">
      @for (achievement of requirement.globalAchievementsCount; track achievement) {
      <div class="achievement" [ghs-label]="'scenario.requirements.globalCount'"
        [ghs-label-args]="[achievement.name, (achievement.required - achievement.count), achievement.required]">
      </div>
      }
    </div>
    <div class="global">
      @for (achievement of requirement.globalAchievementsMissing; track achievement) {
      <div class="achievement" [ghs-label]="'scenario.requirements.globalMissing'" [ghs-label-args]="[achievement]">
      </div>
      }
    </div>
    <div class="campaign-stickers">
      @for (campaignSticker of requirement.campaignStickers; track campaignSticker) {
      <div class="achievement" [ghs-label]="'scenario.requirements.campaignStickers'"
        [ghs-label-args]="[campaignSticker]">
      </div>
      }
    </div>
    <div class="campaign-stickers">
      @for (campaignStickerCount of requirement.campaignStickersCount | trackUUID; track
      campaignStickerCount._trackUUID) {
      <div class="achievement" [ghs-label]="'scenario.requirements.campaignStickersCount'"
        [ghs-label-args]="[campaignStickerCount.name, (campaignStickerCount.required - campaignStickerCount.count), campaignStickerCount.required]">
      </div>
      }
    </div>
    <div class="campaign-stickers">
      @for (campaignSticker of requirement.campaignStickersMissing; track campaignSticker) {
      <div class="achievement" [ghs-label]="'scenario.requirements.campaignStickersMissing'"
        [ghs-label-args]="[campaignSticker]"></div>
      }
    </div>
    <div class="buildings">
      @for (building of requirement.buildings; track building) {
      <div class="achievement" [ghs-label]="'scenario.requirements.buildings'" [ghs-label-args]="[building]"></div>
      }
    </div>
    <div class="buildings">
      @for (buildingLevel of requirement.buildingsLevel | trackUUID; track buildingLevel._trackUUID) {
      <div class="achievement" [ghs-label]="'scenario.requirements.buildingsLevel'"
        [ghs-label-args]="[buildingLevel.name, buildingLevel.level]">
      </div>
      }
    </div>
    <div class="buildings">
      @for (building of requirement.buildingsMissing; track building) {
      <div class="achievement" [ghs-label]="'scenario.requirements.buildingsMissing'" [ghs-label-args]="[building]">
      </div>
      }
    </div>
    <div class="characters">
      @for (character of requirement.characters; track character) {
      <div class="characters" [ghs-label]="'scenario.requirements.characters'"
        [ghs-label-args]="[scenarioData.edition, character]"></div>
      }
    </div>
    <div class="characters">
      @for (character of requirement.charactersMissing; track character) {
      <div class="characters" [ghs-label]="'scenario.requirements.charactersMissing'"
        [ghs-label-args]="[scenarioData.edition, character]">
      </div>
      }
    </div>
    @if (requirement.scenarios.length) {
    <div class="scenarios">
      <div class="requires" [ghs-label]="'scenario.requirements.scenarios'"></div>
      @for (requires of requirement.scenarios; track requires; let i = $index) {
      <div class="scenarios">
        @for (scenario of requires; track scenario; let j = $index) {
        <div class="scenario" [ghs-label]="'scenario.requirements.scenarios.scenario'"
          [ghs-label-args]="[scenario, scenarioData.edition]">
        </div>
        @if (requires.length > 1 && j < requires.length -1) { <div class="separator"
          [ghs-label]="'scenario.requirements.scenarios.and'">
      </div>
      }
      }
    </div>
    @if (requirement.scenarios.length > 1 && i < requirement.scenarios.length -1) { <div class="separator"
      [ghs-label]="'scenario.requirements.scenarios.or'">
  </div>
  }
  }
</div>
}
</div>
@if (i < requirements.length -1) { <span class="separator"><span [ghs-label]="'or'"></span></span>
  }
  }

  @if (allToggle && !hideAll) {
  <label class="checkbox">
    <input type="checkbox" [(ngModel)]="all" (change)="update()"><span [ghs-label]="'scenario.requirements.all'"></span>
  </label>
  }

  </div>